import { FormikErrors } from 'formik'
import { TFunction } from 'i18next'
import { ChangeError, ChangeResponseErrorObject } from '../../../../types'
import { ContractChangeWithObjectPayload } from '../types'

export const getValidationErrors = (errors: ChangeError, t: TFunction): FormikErrors<ContractChangeWithObjectPayload> => {
  const validationErrors = {
    validFrom: undefined,
    changes: {
      bonus: undefined,
      salary: undefined,
      nationalReferenceLevel: undefined,
      governmentJobTitle: undefined,
      employeeLevel: undefined,
    },
  }
  if (errors.validFrom) {
    validationErrors.validFrom = t(
      `formError.${errors.validFrom.message}`,
      errors.validFrom.props ? { ...JSON.parse(errors.validFrom.props) } : {},
    )
  }

  if (errors.bonus) {
    validationErrors.changes.bonus = t(`formError.${errors.bonus.message}`, formatErrorProps(errors.bonus, t))
  }
  if (errors.salary) {
    validationErrors.changes.salary = t(`formError.${errors.salary.message}`, formatErrorProps(errors.salary, t))
  }
  if (errors.employeeLevel) {
    validationErrors.changes.employeeLevel = t(`formError.${errors.employeeLevel.message}`, formatErrorProps(errors.employeeLevel, t))
  }
  if (errors.nationalReferenceLevel) {
    validationErrors.changes.nationalReferenceLevel = t(
      `formError.${errors.nationalReferenceLevel.message}`,
      formatErrorProps(errors.nationalReferenceLevel, t),
    )
  }
  if (errors.governmentJobTitle) {
    validationErrors.changes.governmentJobTitle = t(
      `formError.${errors.governmentJobTitle.message}`,
      formatErrorProps(errors.governmentJobTitle, t),
    )
  }

  return validationErrors
}

const formatErrorProps = (error: ChangeResponseErrorObject, t: TFunction) => {
  if (!error || !error.props) return {}
  const propsObj = JSON.parse(error.props)
  if (error.message === 'updatesRestrictedTo' && propsObj.date !== undefined && propsObj.date !== null && propsObj.date !== '') {
    propsObj.date = t(`global.month.${propsObj.date}`)
  }
  return propsObj
}
